// extracted by mini-css-extract-plugin
module.exports = {"button":"sentiment-tracker-button_button__3_rMb","good":"sentiment-tracker-button_good__zUTYY","bad":"sentiment-tracker-button_bad__1xaTe"};